import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const Comercio = () => {
  const wpp = generateWhatsAppLink('comercio', 'comercio-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Comércio | Sustenta LED</title>
        <meta name="description" content="Distribuidora e atacadista de LED para comércio. Iluminação para lojas, supermercados, restaurantes e redes com produtos homologados e suporte especializado." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Comércio</h1>
              <p>Oferecemos soluções de iluminação LED para ambientes comerciais como lojas, supermercados, restaurantes e redes. Somos atacadistas, distribuidores e representantes, com portfólio completo de plafons, painéis, trilhos, spots e refletores para vitrines e áreas internas.</p>
              <p>Priorizamos conforto visual, valorização de produtos e economia em consumo. Nossa equipe orienta temperatura de cor, IRC e fotometria ideal para cada área do seu estabelecimento, garantindo uma ambientação profissional.</p>
              <p>Atendemos demandas em escala com prazos curtos, faturamento para PJ e logística nacional. Solicite cotação e receba condições exclusivas para o seu segmento.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/clientes/banner_comercio.jpg" alt="Luminárias de LED para Comércio - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Comercio;
